





































import demo1 from './demo1.vue';
import Anchor from '@/packages/d-anchor';
import Vue from 'vue';
import Component from 'vue-class-component';
import MBadge from '@/packages/m-badge';
import title from '../../packages/m-badge/demo/README.md';
import props from '../../packages/m-badge/demo/props.md';

Vue.use(Anchor);
Vue.use(MBadge);
@Component({
  name: 'ComponentDemo',
  components: {
    demo1
  }
})
export default class ComponentDemo extends Vue {
  public title = title;
  public props = props;

  public getContainer() {
    return document.getElementById('app-content');
  }
}
